var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get, getRawValue } from '../../utils/get';
import { getImageObject } from '../../adapters/structure-data-utils';
import { CONTEXT_PROPS } from '../../types/ContextProps';
export var getServiceUrl = function (serviceResponse) {
    if (serviceResponse === void 0) { serviceResponse = {}; }
    return serviceResponse.urls &&
        get(serviceResponse, 'urls.servicePageUrl.base').concat(get(serviceResponse, 'urls.servicePageUrl.path'));
};
export var getOfferAvailability = function (_a) {
    var _b = _a === void 0 ? {} : _a, isBookable = _b.isBookable, isFullyBooked = _b.isFullyBooked, isServiceAvailable = _b.isServiceAvailable, isTooEarlyToBook = _b.isTooEarlyToBook, isTooLateToBook = _b.isTooLateToBook;
    return isBookable &&
        isServiceAvailable &&
        !isTooEarlyToBook &&
        !isTooLateToBook &&
        !isFullyBooked
        ? 'OnlineOnly'
        : 'SoldOut';
};
export var getUrlParts = function (url) {
    if (typeof url !== 'string') {
        return undefined;
    }
    var _a = 
    // eslint-disable-next-line no-useless-escape
    (/^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/gim.exec(url) || [])[0], base = _a === void 0 ? '' : _a;
    var path = url.replace(base, '');
    return {
        base: base,
        path: path,
    };
};
export var renderStructureData = function (item, calculatedData, IDs) {
    var serviceResponse = item.serviceResponse, bookingsPolicyDto = item.bookingsPolicyDto;
    if (calculatedData[IDs.SD_DISABLE_SCHEMA]) {
        return {};
    }
    var _a = calculatedData, _b = IDs.NAME, name = _a[_b], _c = IDs.DESCRIPTION, description = _a[_c], _d = IDs.STATUS, _e = _a[_d], status = _e === void 0 ? '' : _e, _f = IDs.CALCULATED_SERVICE_URL, url = _a[_f], _g = IDs.PRICE_AMOUNT, price = _a[_g], _h = IDs.CURRENCY, priceCurrency = _a[_h], _j = IDs.END_DATE, validUntil = _a[_j], _k = IDs.SESSION_TYPE, sdType = _a[_k];
    var offerAvailability = getOfferAvailability(bookingsPolicyDto);
    var domain = get(serviceResponse, 'urls.servicePageUrl.base');
    var imagesData = (getRawValue(serviceResponse, 'service.info.images') || []).map(function (_a) {
        var imageURL = _a.url, width = _a.width, height = _a.height;
        return ({
            url: imageURL,
            width: width,
            height: height,
        });
    });
    var shouldRender = !!name && status.toLowerCase() === 'created';
    var providerName = get(item, "context." + CONTEXT_PROPS.BUSINESS_NAME);
    return shouldRender
        ? __assign(__assign(__assign(__assign({ '@context': 'http://schema.org/', '@type': sdType, name: name }, (description ? { description: description } : {})), (sdType.toLowerCase() === 'course' && providerName
            ? {
                provider: {
                    '@type': 'Organization',
                    name: providerName,
                    sameAs: domain,
                    url: domain,
                },
            }
            : {})), getImageObject('image', imagesData)), (parseInt(price) > 0
            ? {
                offers: __assign({ '@type': 'offer', availability: "http://schema.org/" + offerAvailability, price: price,
                    priceCurrency: priceCurrency,
                    url: url }, (validUntil ? { validUntil: validUntil } : {})),
            }
            : {})) : {};
};
